/**
 * Takes text content and changes value in contact-person hidden field.
 * The value will be passt trough the post_subject.php template and inserted
 * as default value of the contact form.
 */
export default class FormSubject {
  /**
   * constructor
   * @param {Object} config - optional config object
   */
  constructor(config = {}) {
    this.config = {
      selector: {
        subjectString: '[data-form-subject]',
        hiddenField: '[data-form-subject-field]',
      },
      ...config,
    };
    /**
     * just select the first selector
     * @type {Element}
     */
    this.subjectField = document.querySelector(this.config.selector.subjectString);
    if (!this.subjectField) {
      return;
    }
    this.copySubject();
  }

  /**
   * Copies inner text of chosen subject tag into all hidden fields of the contact-person-form.
   * When multiple elements are marked as subject it will always take the first maked element
   * for the subject.
   */
  copySubject() {
    this.subject = this.subjectField.innerText.trim();
    this.hiddenFields = document.querySelectorAll(this.config.selector.hiddenField);
    if (this.subject !== '' && this.hiddenFields.length) {
      this.hiddenFields.forEach((field) => {
        // eslint-disable-next-line no-param-reassign
        field.value = this.subject;
      });
    }
  }
}
